require('./bootstrap');

import Vue from 'vue';
import VueMeta from 'vue-meta'
import { App, plugin } from '@inertiajs/inertia-vue'
import PortalVue from 'portal-vue';
import { InertiaProgress } from '@inertiajs/progress/src';
import Permissions from './Mixins/Permissions';

Vue.mixin(Permissions);
Vue.use(plugin)
Vue.use(PortalVue);
Vue.use(VueMeta);
Vue.mixin({
  methods: {
    route,
/*    can: function (permissionName) {
      let hasAccess = false;
      axios.get(`/permission/${permissionName}`)
        .then(() => {
          hasAccess = true;
        }).catch(() => {
        hasAccess = false;
      });
      return hasAccess;
    },*/
  }
});

InertiaProgress.init()

const el = document.getElementById('app');

new Vue({
  metaInfo: {
    titleTemplate: (title) => title ? `${title} - Cetelec Service` : 'Cetelec Service'
  },
  render: (h) => h(App, {
      props: {
        initialPage: JSON.parse(el.dataset.page),
        resolveComponent: (name) => require(`./Pages/${name}`).default,
      },
    }),
}).$mount(el);
